import { render } from "./IgnoreBoxesFilter.vue?vue&type=template&id=41b0fe98&scoped=true"
import script from "./IgnoreBoxesFilter.vue?vue&type=script&lang=js"
export * from "./IgnoreBoxesFilter.vue?vue&type=script&lang=js"

import "./IgnoreBoxesFilter.vue?vue&type=style&index=0&id=41b0fe98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b0fe98"]])

export default __exports__